__turbopack_context__.v({
  "className": "totemesansfont_a4204bf6-module__lwZ5gW__className",
  "variable": "totemesansfont_a4204bf6-module__lwZ5gW__variable",
});
